import { CSSObject } from '@emotion/react'
import { sharedColors } from '../sharedDisplays/sharedStyles/colors'

type DisplayProps = {
  [key: string]: number
}

const renderDisplayLayout: DisplayProps = {
  desktopStream: 598,
  mobileStream: 373,
}

const baseStyles = (display: string): CSSObject => ({
  backgroundColor: '#fff',
  borderRadius: 0,
  border: sharedColors.momentBorder,
  display: 'flex',
  flexDirection: 'column',
  width: renderDisplayLayout[display],
})

const getInputStyles = (display: string): CSSObject => ({
  margin: display.includes('mobile') ? '28px 27px' : '25px',
})

const styles = {
  baseStyles,
  getInputStyles,
}

export { styles }
